import { useQueryFetch } from 'sonata-react-components';

import { useIoLineItemSchedules } from '@/components/ioSettings/InsertionOrderForm/hooks/useIoLineItemSchedules';
import { getInsertionOrderFlights } from '@/services/insertionOrder.service';

import type { InsertionOrderFlight } from 'sonata-static-storage/lib/schemas/multiFlight/insertionOrderFlight.schema';

/**
 * Flights and line-item schedules of an insertion order, for the line item date picker. Refetched on every mount
 * (the app QueryClient defaults to `staleTime: Infinity`); nothing is fetched without an IO id.
 * `flights` stays `undefined` until they are loaded.
 */
export function useInsertionOrderSchedules(userId: string, insertionOrderId?: string) {
  const enabled = Boolean(insertionOrderId);
  const lineItems = useIoLineItemSchedules(userId, insertionOrderId ?? '', enabled);
  const { data: flights } = useQueryFetch<InsertionOrderFlight[]>(
    ['ioFlights', insertionOrderId],
    async () => (await getInsertionOrderFlights(userId, insertionOrderId!)).flights ?? [],
    { enabled, staleTime: 0 }
  );

  return { flights, lineItems };
}
